module.exports = __webpack_public_path__ + "img/EuclidEnercity-MediumItalic-WebS.f95c052a.svg";